import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Arrowleftsmall from '../../assets/images/arrowleftsmall.svg'
import Search from '../../assets/images/search.svg'
import Resume from '../../assets/images/description.svg'
import Select from 'react-select'

import {
  Button,
  Col,
  Form,
  Image,
  InputGroup,
  Row,
  ProgressBar,
  Container,
} from 'react-bootstrap'
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import InfoIconImg from '../../assets/images/info-icon.svg'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { dispatch } from '../../redux'
import {
  getAssignBatchListThunk,
  getAssignBatchSkillMatchListThunk,
  resumeAssignToBatchThunk,
} from '../../redux/action/resumeLibraryAction'
import { useSelector } from 'react-redux'
import { Store } from '../../redux/Actions'
import { BarsLoader } from '../../components/Loader'
import Pagination from '../../components/Pagination'
import JdDetailsModal from './AssignToBatchComponents/JdDetailsModal'
import _ from 'lodash'
import { monthsToYearsAndMonths } from '../../util/utils'
import { FormattedMessage } from 'react-intl'
/**
 * ==================================================
 * Global code
 * ==================================================
 */
const abc = [
  {
    id: 1,
    skills: [],
    created_by: {
      id: 226396,
      first_name: 'HrHead',
      last_name: null,
      username: 'HrHead',
      email: 'HrHead@prep.com',
      photo: null,
      mobile_number: '9899998596',
    },
    updated_by: null,
    uuid: null,
    name: 'Abhi Varrier',
    email: '--',
    resume_link: null,
    status: 'D',
    total_experience: null,
    created_at: '2024-04-24T15:03:43.239397+05:30',
    updated_at: '2024-04-25T11:58:53.361865+05:30',
    isChecked: false,
  },
  {
    id: 2,
    skills: [],
    created_by: {
      id: 226396,
      first_name: 'HrHead',
      last_name: null,
      username: 'HrHead',
      email: 'HrHead@prep.com',
      photo: null,
      mobile_number: '9899998596',
    },
    updated_by: null,
    uuid: null,
    name: 'Abc',
    email: 'abc@gnail.com',
    resume_link: null,
    status: 'A',
    total_experience: null,
    created_at: '2024-04-24T15:03:43.245414+05:30',
    updated_at: '2024-04-24T15:03:43.245429+05:30',
    isChecked: false,
  },
]

const itemsPerPage = 10
const AssignToBatch = () => {
  /**
   * ==================================================
   * const variable
   * ==================================================
   */
  const navigate = useNavigate()

  const stateData = useLocation()
  const selectedResume = stateData?.state?.selectedResume?.map((val) => val?.id)
  const resumeListUpdate = stateData?.state?.resumeListUpdate?.filter(
    (val) => val.isChecked === true
  )
  const resumeListData = resumeListUpdate?.map((item) => {
    return { ...item, isChecked: false }
  })

  /**
   * ==================================================
   * Data from redux store
   * ==================================================
   */
  const assignBatchList = useSelector(
    (state: Store) => state?.resumeLibraryReducer?.assignBatchList
  )

  const assignBatchListDropdown = assignBatchList?.map((bt) => ({
    value: bt?.id,
    label: `${bt?.name}${
      bt?.job_description
        ? ' | ' +
          (bt?.job_description?.job_title || '') +
          '  ' +
          (monthsToYearsAndMonths(bt?.job_description?.experience_from) || '') +
          '-' +
          (monthsToYearsAndMonths(bt?.job_description?.experience_to) || '') +
          ' yr'
        : ''
    }`,
  }))

  const assignBatchSkillMatchList = useSelector(
    (state: Store) => state?.resumeLibraryReducer?.assignBatchSkillMatchList
  )?.map((val) => ({
    ...val,
    isChecked: false,
  }))

  const isLoadingAssignBatchSkillMatchList = useSelector(
    (state: Store) =>
      state?.resumeLibraryReducer?.isLoadingAssignBatchSkillMatchList
  )
  /**
   * ==================================================
   * Component state
   * ==================================================
   */
  const [show, setShow] = useState(false)
  const [open, setOpen] = useState(false)
  const [examinationFilter, setExaminationFilter] = useState<{
    value: string
    label: string
  } | null>(null)
  const [page, setPage] = useState(0)
  const [skillMatchResumeListUpdate, setSkillMatchResumeListUpdate] = useState(
    assignBatchSkillMatchList || []
  )
  const [isInitialData, setIsInitialData] = useState(true)

  const [paginatedData, setPaginatedData] = useState(
    (skillMatchResumeListUpdate || [])?.slice(0, itemsPerPage)
  )

  const [isCheckedAll, setIsCheckedAll] = useState(false)
  const [search, setSearch] = useState('')

  /**
   * ==================================================
   * const based on state and redux data
   * ==================================================
   */
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const attachedJd = assignBatchList?.filter(
    (val) => val?.id == examinationFilter?.value
  )?.[0]

  /**
   * ==================================================
   * functionality
   * ==================================================
   */

  const selectedCount = skillMatchResumeListUpdate.filter(
    (val) => val.isChecked === true
  )

  const updateListOfResumeAll = (check) => {
    const updatedListOfItems = skillMatchResumeListUpdate?.map((val) => ({
      ...val,
      isChecked: !check,
    }))
    setSkillMatchResumeListUpdate(updatedListOfItems)
    setIsCheckedAll(!check)
  }
  const updateListOfResume = (itemId, isChecked) => {
    const updatedListOfItems = [...skillMatchResumeListUpdate]
    const question_index = skillMatchResumeListUpdate?.findIndex(
      (item) => item?.id === itemId
    )
    updatedListOfItems[question_index].isChecked = isChecked
    setSkillMatchResumeListUpdate(updatedListOfItems)

    const allCheck = updatedListOfItems.filter(
      (val) => val.isChecked === false
    )?.length
    allCheck > 0 ? setIsCheckedAll(false) : setIsCheckedAll(true)
  }

  const searchDebounce = _.debounce((val) => {
    setSearch(val)
    dispatch(
      getAssignBatchSkillMatchListThunk(
        examinationFilter?.value,
        selectedResume,
        val
      )
    )
    setIsCheckedAll(false)
  }, 500)

  const submitHandler = () => {
    const data = selectedCount?.map((val) => ({
      resume: val?.id,
      skill_ratio: val?.skill_ratio || 0,
      is_invited: true,
    }))

    dispatch(
      resumeAssignToBatchThunk(examinationFilter?.value, data, () =>
        navigate('/resume-library')
      )
    )
  }

  /**
   * ==================================================
   * Side effect handling
   * ==================================================
   */
  useEffect(() => {
    if (examinationFilter?.value) {
      dispatch(
        getAssignBatchSkillMatchListThunk(
          examinationFilter?.value,
          selectedResume,
          undefined
        )
      )
      setIsCheckedAll(false)
    }
  }, [examinationFilter?.value])

  useEffect(() => {
    dispatch(getAssignBatchListThunk())
  }, [])

  // Manual pagination code
  useEffect(() => {
    const newOffset =
      (page * itemsPerPage) % (skillMatchResumeListUpdate?.length || 1)
    const newLimit = (page + 1) * itemsPerPage

    setPaginatedData(skillMatchResumeListUpdate?.slice(newOffset, newLimit))
    setSkillMatchResumeListUpdate((prev) => prev)
  }, [page, skillMatchResumeListUpdate])

  useEffect(() => {
    setSkillMatchResumeListUpdate(assignBatchSkillMatchList)
  }, [examinationFilter?.value, JSON.stringify(assignBatchSkillMatchList)])

  return (
    <>
      <div className="body-bg-gray hr-dashboard0">
        <div className="my-5 container">
          <div className="d-flex mt-3 mb-2 font-size-14">
            <Link to="/resume-library" className="text-muted fw-semibold">
              <FormattedMessage
                id="Resume_Library"
                defaultMessage="Resume Library"
              />
            </Link>
            <i className="fas fa-angle-right fa-fw align-self-center"></i>
            <p className="text-dark fw-semibold m-0">Assign Batch</p>
          </div>
          <div className="card page-card page-content-card h-100">
            <div className="d-flex align-items-center card-header px-4 py-3">
              <Link
                to="/resume-library"
                className="me-3 btn btn-outline-secondary"
              >
                <img src={Arrowleftsmall} alt="Arrowleftsmall" />
              </Link>
              <h4 className="mb-0 font-size-18 fw-600">Assign to Batch </h4>
              <Button
                className="ms-auto btn btn-outline-primary"
                value="next"
                onClick={() => navigate('/resume-library')}
              >
                <FormattedMessage id="Cancel" defaultMessage="cancel" />
              </Button>
              <Button
                className="ms-3 btn btn-primary"
                value="next"
                disabled={selectedCount?.length < 1}
                onClick={submitHandler}
              >
                Assign
              </Button>
            </div>
            <div className="card-body p-4">
              <div className="max-width-950 mx-auto">
                <span className="mb-2 pb-1 text-muted d-block font-size-14">
                  Step 1: Select Batch
                </span>
                <Row className="g-5 mb-5">
                  <Col lg={8}>
                    <Form.Group className="form-group" controlId="formType">
                      <Form.Label>Batch</Form.Label>
                      <Select
                        defaultValue={assignBatchListDropdown[0]}
                        options={assignBatchListDropdown}
                        value={examinationFilter}
                        onChange={(selected) => {
                          setExaminationFilter(selected)
                          setIsInitialData(false)
                        }}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select examination type"
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group
                      className="form-group mb-0"
                      controlId="formEmailID"
                    >
                      <Form.Label className="mb-3">Job Descripition</Form.Label>
                      <br />
                      <Image src={InfoIconImg} className="me-2" />
                      {examinationFilter?.value ? (
                        <span
                          className="text-primary pointer"
                          onClick={handleShow}
                        >
                          {`${attachedJd?.job_description?.job_title || ''}  
                        (${
                          monthsToYearsAndMonths(
                            attachedJd?.job_description?.experience_from
                          ) || 0
                        }-${
                            monthsToYearsAndMonths(
                              attachedJd?.job_description?.experience_to
                            ) || ''
                          } years)`}
                        </span>
                      ) : (
                        '-'
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <span className="mb-3 pb-1 text-muted d-block font-size-14">
                  Step 2: Assign best candidates for the role and allocate them
                  to the batch
                </span>
                <Row xs={1} sm={1} lg={2} className="mb-3">
                  <Col lg={4}>
                    <Form.Group
                      className="form-group mb-0"
                      controlId="formEmailID"
                    >
                      <Form.Label className="mb-3">&nbsp;</Form.Label>
                      {examinationFilter?.value && (
                        <InputGroup className="form-input-group left">
                          <Button
                            variant="outline-secondary"
                            id="button-addon1"
                          >
                            <img src={Search} alt="Icon Found" />
                          </Button>
                          <Form.Control
                            placeholder="Search by candidate name"
                            aria-label="Example text with button addon"
                            aria-describedby="basic-addon1"
                            type="search"
                            onChange={(e) => searchDebounce(e.target.value)}
                          />
                        </InputGroup>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <TableContainer className="custom-table mt-4">
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          {
                            <Form.Check
                              className="select-resume"
                              type={'checkbox'}
                              id={'ResumeAllSkill'}
                              checked={isCheckedAll}
                              disabled={isInitialData}
                              onChange={() =>
                                updateListOfResumeAll(isCheckedAll)
                              }
                            />
                          }
                        </TableCell>
                        <TableCell>Candidate name</TableCell>
                        <TableCell>Skill set</TableCell>
                        <TableCell>Skill set match</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isLoadingAssignBatchSkillMatchList ? (
                        <TableRow>
                          <TableCell colSpan={4} className="text-center">
                            <BarsLoader height={'100px'} />
                          </TableCell>
                        </TableRow>
                      ) : paginatedData?.length || resumeListData?.length ? (
                        (!isInitialData ? paginatedData : resumeListData)?.map(
                          (can) => (
                            <TableRow className="border-bottom border-light">
                              <TableCell>
                                <Form.Check
                                  className="select-resume"
                                  key={can?.id}
                                  type={'checkbox'}
                                  id={'skill' + can?.id.toString()}
                                  checked={can?.isChecked}
                                  disabled={isInitialData}
                                  onChange={() =>
                                    updateListOfResume(can?.id, !can?.isChecked)
                                  }
                                />
                              </TableCell>
                              <TableCell>{can?.name || '-'}</TableCell>
                              <TableCell>
                                {can?.skills?.length > 0 ? (
                                  <>
                                    {can?.skills?.length < 5
                                      ? can?.skills
                                          ?.map((skill) => skill?.skill_name)
                                          ?.join(', ')
                                      : can?.skills
                                          .slice(0, 5)
                                          ?.map((skill) => skill?.skill_name)
                                          ?.join(', ') +
                                        `, +${
                                          can?.skills
                                            ?.map((skill) => skill?.skill_name)
                                            ?.splice(5)?.length
                                        } more`}
                                  </>
                                ) : (
                                  '-'
                                )}
                              </TableCell>
                              <TableCell>
                                {can?.skill_ratio || 0}%
                                <br />
                                <ProgressBar
                                  variant={
                                    can?.skill_ratio <= 40
                                      ? 'danger'
                                      : can?.skill_ratio >= 70
                                      ? 'success'
                                      : 'warning'
                                  }
                                  now={can?.skill_ratio || 0}
                                  className="mt-1"
                                  style={{ height: '0.675rem' }}
                                />
                              </TableCell>
                            </TableRow>
                          )
                        )
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} className="text-center">
                            <FormattedMessage
                              id="No_Records_Found"
                              defaultMessage="No records found"
                            />
                          </TableCell>
                        </TableRow>
                      )}

                      {[]?.length > 1 ? (
                        abc?.map((row) => (
                          <>
                            <TableRow
                              sx={{ '& > *': { borderBottom: 'unset' } }}
                              className="border-bottom border-light"
                            >
                              <TableCell>
                                <div className="d-flex align-items-center">
                                  <Form.Check
                                    className="me-2 select-resume"
                                    type={'checkbox'}
                                    id={`${row?.id}`}
                                    checked={row?.isChecked}
                                  />
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                    onClick={() => setOpen(!open)}
                                  >
                                    {open ? (
                                      <KeyboardArrowUpIcon />
                                    ) : (
                                      <KeyboardArrowDownIcon />
                                    )}
                                  </IconButton>
                                </div>
                              </TableCell>
                              <TableCell>Avnit Kaur</TableCell>
                              <TableCell>
                                React.js, EcmaScript, JSON, Immutable, +2
                              </TableCell>
                              <TableCell>
                                30%
                                <br />
                                <ProgressBar
                                  variant="danger"
                                  now={40}
                                  className="mt-1"
                                  style={{ height: '0.675rem' }}
                                />
                              </TableCell>
                            </TableRow>
                            {open && (
                              <TableRow>
                                <TableCell colSpan={6}>
                                  <Collapse
                                    in={open}
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <Container>
                                      <Row>
                                        <Col>
                                          <p className="fw-normal font-size-14 text-black-400 mb-2">
                                            Job Title
                                          </p>
                                          <p className="lato-text">
                                            react Developer
                                          </p>
                                        </Col>
                                        <Col>
                                          <p className="fw-normal font-size-14 text-black-400 mb-2">
                                            <FormattedMessage
                                              id="Experience"
                                              defaultMessage="Experience"
                                            />
                                          </p>
                                          <p className="lato-text">5 years</p>
                                        </Col>
                                        <Col>
                                          <p className="fw-normal font-size-14 text-black-400 mb-2">
                                            Email
                                          </p>
                                          <p className="lato-text mb-1">
                                            Avnit.kaur@gmil.com
                                          </p>
                                        </Col>
                                        <Col>
                                          <p className="fw-normal font-size-14 text-black-400 mb-2">
                                            Number
                                          </p>
                                          <p className="lato-text mb-1">
                                            6958693658
                                          </p>
                                        </Col>
                                        <Col>
                                          <p className="fw-normal font-size-14 text-black-400 mb-2">
                                            <FormattedMessage
                                              id="Resume"
                                              defaultMessage="Resume"
                                            />
                                          </p>
                                          <Image
                                            src={Resume}
                                            alt="resume"
                                            className="pointer"
                                          />

                                          {/* )} */}
                                        </Col>
                                      </Row>
                                    </Container>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                            )}
                          </>
                        ))
                      ) : (
                        <span></span>
                      )}
                    </TableBody>
                  </Table>
                  {skillMatchResumeListUpdate?.length > itemsPerPage &&
                    examinationFilter?.value && (
                      <Pagination
                        page={page}
                        setPage={setPage}
                        tableCount={skillMatchResumeListUpdate?.length}
                        itemsPerPage={itemsPerPage}
                      />
                    )}
                </TableContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <JdDetailsModal
        handleClose={handleClose}
        show={show}
        attachedJd={attachedJd}
      />
    </>
  )
}

export default AssignToBatch
